import { render } from "./DocumentAcceptanceDialog.vue?vue&type=template&id=83761dbc&scoped=true"
import script from "./DocumentAcceptanceDialog.vue?vue&type=script&lang=js"
export * from "./DocumentAcceptanceDialog.vue?vue&type=script&lang=js"

import "./DocumentAcceptanceDialog.vue?vue&type=style&index=0&id=83761dbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83761dbc"]])

export default __exports__